export default __webpack_public_path__ + "static/logo-55536d86a8a5133eab7c9cc529476e40.png";